import { reducers as norce } from './norce';
import { reducer as stores } from './stores';
import { reducer as compare } from './compare';

export const reducers = {
    ...norce,
    compare,
    stores,
};
